import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  @Output() eventEmpresa: EventEmitter<any> = new EventEmitter();
  constructor() { }

    setItemsessionStorage(key:string,value:any){
      sessionStorage.setItem(key, JSON.stringify(value));
    }

    getItemsessionStorage(key:string){
      return sessionStorage.getItem(key);
    }
    removeItemsessionStorage(key:string){
      sessionStorage.removeItem(key)
    }

    setItemlocalStorage(key:string,value:any){
      localStorage.setItem(key, JSON.stringify(value));
    }

    getItemlocalStorage(key:string){
      return localStorage.getItem(key);
    }
    removeItemlocalStorage(key:string){
      localStorage.removeItem(key)
    }
}
